import { StatusResponse } from '@ardoq/api-types';
import { fetchJson } from './api';
import { ApiResponse } from './types';

const fetchStatus = (timeout?: number): ApiResponse<StatusResponse> => {
  const request = new Request('/api/status', {
    signal: timeout ? AbortSignal.timeout(timeout) : undefined,
  });
  return fetchJson<StatusResponse>(request);
};

export const statusApi = {
  fetchStatus,
};
